import { useEffect, useState } from "react";
import ApiClient from "src/config/ApiClient";

// For read-only lists. Failed requests remain errors, never successful empty data.
export default function useApiList(path) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ path: null, data: [], status: "idle" });

  useEffect(() => {
    if (!path) return;
    const controller = new AbortController();
    setState({ path, data: [], status: "loading" });

    const load = async () => {
      try {
        const response = await ApiClient.get(path, { signal: controller.signal });
        const data = response.data?.data;
        if (!Array.isArray(data)) throw new Error("Invalid list response");
        if (!controller.signal.aborted) setState({ path, data, status: "success" });
      } catch (error) {
        if (!controller.signal.aborted) setState({ path, data: [], status: "error" });
      }
    };
    load();
    return () => controller.abort();
  }, [path, attempt]);

  const current = path && state.path === path
    ? state
    : { data: [], status: path ? "loading" : "idle" };
  return { ...current, retry: () => setAttempt((value) => value + 1) };
}
